import { Component } from '@verndale/core';

class OrbsBackground extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el
    };

    const getPageHeight = this.getPageHeight();
    //create orbs and append them to the dom. calculate the number of orbs based on the height of the page divided by 66% of the width
    const numberOfOrbs = Math.floor(getPageHeight / (window.innerWidth * 0.66));

    for (let i = 0; i < numberOfOrbs; i++) {
      const orb = document.createElement('div');
      orb.classList.add('orbs-background__orb-item');
      orb.style.top = `${i * (window.innerWidth * 0.75)}px`;
      //offset a little bit the horizontal positive and negative position of the orbs randomly
      orb.style.left = `${Math.floor(Math.random() * 10) % 2 === 0 ? -1 : 1} * ${Math.floor(Math.random() * 10)}px`;
      (this.dom.el as HTMLElement).appendChild(orb);
    }

    requestAnimationFrame(() => {
      (this.dom.el as HTMLElement).classList.add('loaded');
    });
  }

  addListeners() {
    window.matchMedia('(min-width: 768px)').onchange = () => {
      this.el.innerHTML = '';
      this.setupDefaults();
    };
  }

  getPageHeight() {
    const body = document.body,
      html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    return height;
  }
}

export default OrbsBackground;
